"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Radio_context_1 = require("./Radio.context");
const Radio_styles_1 = require("./Radio.styles");
exports.RadioGroup = (0, react_1.forwardRef)((props, ref) => {
    const { value, fullWidth, onChange, children, className, inline } = props;
    const [checkedValue, setCheckedValue] = (0, react_1.useState)(value);
    (0, react_1.useEffect)(() => {
        if (props.value)
            setCheckedValue(props.value);
    }, [props.value]);
    const handleChange = (0, react_1.useCallback)((event) => {
        setCheckedValue(event.target.value);
        if (onChange)
            onChange(event);
    }, [onChange]);
    return ((0, jsx_runtime_1.jsx)(Radio_styles_1.StyledRadioGroup, { ref: ref, className: className, fullWidth: fullWidth, inline: inline, children: (0, jsx_runtime_1.jsx)(Radio_context_1.RadioContext.Provider, { value: { checkedValue, onChange: handleChange }, children: children }) }));
});
exports.RadioGroup.displayName = 'RadioGroup';
